import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  tradePill: {
    '&:not(:last-child)': {
      marginRight: '8px',
    },
    marginBottom: '8px',
    marginLeft: '0 !important',
  },
}));
